var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FEEFF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.0001 26H24",
    stroke: "#DF1C41",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3327 28.5L38.8727 35.3991C38.6957 38.054 38.6073 39.3815 37.7422 40.1907C36.8772 41 35.5468 41 32.886 41H32.1127C29.4519 41 28.1215 41 27.2565 40.1907C26.3914 39.3815 26.303 38.054 26.126 35.3991L25.666 28.5",
    stroke: "#DF1C41",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 31L30.5 36",
    stroke: "#DF1C41",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 31L34.5 36",
    stroke: "#DF1C41",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27 26C27.0559 26 27.0838 26 27.1091 25.9994C27.9326 25.9785 28.659 25.4549 28.9392 24.6803C28.9478 24.6565 28.9567 24.63 28.9743 24.577L29.0714 24.2857C29.1543 24.0371 29.1957 23.9128 29.2507 23.8072C29.47 23.3861 29.8757 23.0936 30.3446 23.0188C30.4621 23 30.5932 23 30.8553 23H34.1447C34.4068 23 34.5379 23 34.6554 23.0188C35.1243 23.0936 35.53 23.3861 35.7493 23.8072C35.8043 23.9128 35.8457 24.0371 35.9286 24.2857L36.0257 24.577C36.0433 24.6299 36.0522 24.6565 36.0608 24.6803C36.341 25.4549 37.0674 25.9785 37.8909 25.9994C37.9162 26 37.9441 26 38 26",
    stroke: "#DF1C41",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDel);
export default __webpack_public_path__ + "static/media/del.98ae2d371f2c85e0730525b14779aee7.svg";
export { ForwardRef as ReactComponent };